import { useContext } from "react";
import { GlobalContext } from "../context";
import DashboardLayout from "./DashboardLayout";
import DashboardVideoLayout from "./DashboardVideoLayout";
import MainLayouts from "./MainLayouts";

/**
 * Renders the right layout based on auth state and page type.
 *
 * - Logged in + isVideo  → DashboardVideoLayout (topbar only, no sidebar)
 * - Logged in            → DashboardLayout (full sidebar + topbar)
 * - Guest                → MainLayouts (public header + footer)
 */
export default function ConditionalLayout({ children, showFooter, isVideo }) {
  const {
    authState: { loggedIn },
  } = useContext(GlobalContext);

  if (loggedIn) {
    if (isVideo) {
      return <DashboardVideoLayout>{children}</DashboardVideoLayout>;
    }
    return <DashboardLayout>{children}</DashboardLayout>;
  }

  return <MainLayouts showFooter={showFooter}>{children}</MainLayouts>;
}
